module.exports = __webpack_public_path__ + "img/order_submit_error.59fed92c.png";